export default {
  "mainVegetable": "groennsaker",
  "mainVegetable/01": "groennsaker/auberginer",
  "mainVegetable/02": "groennsaker/asparges",
  "mainVegetable/03": "groennsaker/avokado",
  "mainVegetable/04": "groennsaker/rodbeter",
  "mainVegetable/05": "groennsaker/brokkoli",
  "mainVegetable/06": "groennsaker/gulrotter",
  "mainVegetable/07": "groennsaker/selleri",
  "mainVegetable/08": "groennsaker/sjampinjonger",
  "mainVegetable/09": "groennsaker/kal",
  "mainVegetable/10": "groennsaker/rosenkal",
  "mainVegetable/11": "groennsaker/kinakal",
  "mainVegetable/12": "groennsaker/blomkal",
  "mainVegetable/13": "groennsaker/coleslaw",
  "mainVegetable/14": "groennsaker/agurker",
  "mainVegetable/15": "groennsaker/squash",
  "mainVegetable/16": "groennsaker/endiver",
  "mainVegetable/17": "groennsaker/spinat",
  "mainVegetable/18": "groennsaker/hestebonner",
  "mainVegetable/19": "groennsaker",
  "mainVegetable/20": "groennsaker",
  "mainVegetable/21": "groennsaker/torkede-bonner",
  "mainVegetable/22": "groennsaker/aspargesbonner",
  "mainVegetable/23": "groennsaker/linser",
  "mainVegetable/24": "groennsaker/gronnsaksblanding",
  "mainVegetable/25": "groennsaker/mais",
  "mainVegetable/26": "groennsaker/salatblanding",
  "mainVegetable/27": "groennsaker/nepe",
  "mainVegetable/28": "groennsaker/lok",
  "mainVegetable/29": "groennsaker/edamamebonner",
  "mainVegetable/30": "groennsaker/paprika",
  "mainVegetable/31": "groennsaker/poteter",
  "mainVegetable/32": "groennsaker/bonnespirer",
  "mainVegetable/33": "groennsaker/reddiker",
  "mainVegetable/34": "groennsaker/bladsalat",
  "mainVegetable/35": "groennsaker/bataviasalat",
  "mainVegetable/36": "groennsaker/isbergsalat",
  "mainVegetable/37": "groennsaker",
  "mainVegetable/38": "groennsaker/rissalat",
  "mainVegetable/39": "groennsaker/romanosalat",
  "mainVegetable/40": "groennsaker",
  "mainVegetable/41": "groennsaker/salat",
  "mainVegetable/42": "groennsaker/feldsalat",
  "mainVegetable/43": "groennsaker/ruccola",
  "mainVegetable/44": "groennsaker",
  "mainVegetable/45": "groennsaker",
  "mainVegetable/46": "groennsaker/tomater",
  "mainVegetable/47": "groennsaker/limabonner",
  "mainVegetable/48": "groennsaker/kikerter",
  "mainVegetable/49": "groennsaker/purrelok",
  "mainVegetable/50": "groennsaker/gresskar",
  "mainVegetable/51": "groennsaker/rode-kidneybonner",
  "mainVegetable/52": "groennsaker/epler",
  "mainVegetable/53": "groennsaker/kastanjer",
  "mainVegetable/54": "groennsaker/plommer",
  "mainVegetable/55": "groennsaker",
  "mainVegetable/56": "groennsaker/sorte-oliven",
  "mainVegetable/57": "groennsaker/artisjokker",
  "mainVegetable/58": "groennsaker/rod-paprika",
  "mainVegetable/59": "groennsaker",
  "mainVegetable/60": "groennsaker",
  "mainVegetable/61": "groennsaker/ratatouille",
  "mainVegetable/62": "groennsaker/couscous",
  "mainVegetable/63": "groennsaker",
  "mainVegetable/64": "groennsaker",
  "mainVegetable/65": "groennsaker",
  "mainVegetable/66": "groennsaker",
  "mainVegetable/67": "groennsaker/rode-linser",
  "mainVegetable/68": "groennsaker/quinoa",
  "mainVegetable/69": "groennsaker/spelt",
  "mainVegetable/70": "groennsaker/bulgur",
  "mainVegetable/71": "groennsaker/rodkal",
  "mainVegetable/72": "groennsaker/gronnkal",
  "mainVegetable/73": "groennsaker/kjorvel",
  "mainVegetable/74": "groennsaker",
  "mainVegetable/75": "groennsaker/belgfrukter",
  "mainVegetable/76": "groennsaker/sotpoteter",
  "mainVegetable/77": "groennsaker/gresskar",
  "mainVegetable/78": "groennsaker",
  "mainVegetable/79": "groennsaker/bonner",
  "mainVegetable/80": "groennsaker/erter-og-karotter",
  "mainVegetable/81": "groennsaker/erter",
  "mainVegetable/82": "groennsaker/edamamebonner",
  "mainVegetable/83": "groennsaker",
  "mainVegetable/84": "groennsaker",
  "mainVegetable/85": "groennsaker",
  "mainVegetable/86": "groennsaker",
  "mainVegetable/87": "groennsaker",
  "mainVegetable/88": "groennsaker",
  "mainVegetable/89": "groennsaker",
  "mainVegetable/90": "groennsaker/pastinakk",
  "mainVegetable/91": "groennsaker",
  "mainVegetable/92": "groennsaker/bonneblanding",
  "mainVegetable/93": "groennsaker/sorte-bonner",
  "mainVegetable/94": "groennsaker/spisskal",
  "mainVegetable/95": "groennsaker/hvite-bonner",
  "mainVegetable/96": "groennsaker",
  "mainVegetable/97": "groennsaker",
  "mainVegetable/98": "groennsaker",
  "season": "arstid",
  "season/1": "arstid/sommer",
  "season/2": "arstid/host",
  "season/3": "arstid/vinter",
  "season/4": "arstid/var",
  "season/5": "arstid",
  "technologie": "teknologi",
  "technologie/AC01": "teknologi/hermetikk",
  "technologie/AD01": "teknologi",
  "technologie/AG01": "teknologi",
  "technologie/AT01": "teknologi",
  "recipeDish": "rett",
  "recipeDish/ACC": "rett/tilbehor",
  "recipeDish/APE": "rett",
  "recipeDish/DES": "rett/dessert",
  "recipeDish/ENT": "rett/forrett",
  "recipeDish/PLAT": "rett/hovedrett",
  "recipeDish/SAL": "rett/salat",
  "recipeDish/SNA": "rett/snacks",
  "recipeDish/PDE": "rett/frokost",
  "recipeDish/DEJ": "rett/lunsj",
  "recipeDish/TRA": "rett/tradisjonell",
  "recipeDish/GOU": "rett/gourmet",
  "recipeDish/ETH": "rett/etnisk",
  "recipeDish/FCH": "rett/barnevennlig",
  "recipeDish/SOU": "rett/suppe",
  "pred-recipeTimingCook-facet": "tilberedningstid",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "tilberedningstid/0-15-minutter",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "tilberedningstid/15-30-minutter",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "tilberedningstid/30-45-minutter",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "tilberedningstid/45-minutter",
  "pred-recipeTimingPreparation-facet": "forberedelsestid",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "forberedelsestid/0-15-minutter",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "forberedelsestid/15-30-minutter",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "forberedelsestid/30-45-minutter",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "forberedelsestid/45-minutter",
  "pred-recipeCost-Facet": "budsjett",
  "pred-recipeCost-Facet/petit": "budsjett/lavt",
  "pred-recipeCost-Facet/moyen": "budsjett/middels",
  "pred-recipeCost-Facet/grand": "budsjett/hoyt",
  "recipeDifficulty": "vanskelighetgrad",
  "recipeDifficulty/1": "vanskelighetgrad/lett",
  "recipeDifficulty/2": "vanskelighetgrad/middels",
  "recipeDifficulty/3": "vanskelighetgrad/vanskelig",
  "recipeDishNumber": "antall-porsjoner",
  "recipeDishNumber/1": "antall-porsjoner/1",
  "recipeDishNumber/2": "antall-porsjoner/2",
  "recipeDishNumber/3": "antall-porsjoner/3",
  "recipeDishNumber/4": "antall-porsjoner/4",
  "recipeDishNumber/5": "antall-porsjoner/5",
  "recipeDishNumber/6": "antall-porsjoner/6",
  "recipeDishNumber/7": "antall-porsjoner/7",
  "recipeDishNumber/8": "antall-porsjoner/8",
  "productTheme": "produkttemaer",
  "productTheme/ACC": "produkttemaer/tilbehor",
  "productTheme/BEA": "produkttemaer/belgfrukter",
  "productTheme/BIS": "produkttemaer/bonner-i-saus",
  "productTheme/BIO": "produkttemaer/okologisk",
  "productTheme/CAN": "produkttemaer/hermetikk",
  "productTheme/CER": "produkttemaer",
  "productTheme/CLS": "produkttemaer/klassikere",
  "productTheme/DLE": "produkttemaer/gronnsaker",
  "productTheme/EDR": "produkttemaer/mini-packs",
  "productTheme/ENT": "produkttemaer/forretter",
  "productTheme/FRZ": "produkttemaer/frossenmat",
  "productTheme/FSD": "produkttemaer/salatingredienser",
  "productTheme/FSH": "produkttemaer",
  "productTheme/ING": "produkttemaer/ingredienser-til-mine-oppskrifter",
  "productTheme/JAR": "produkttemaer",
  "productTheme/LBW": "produkttemaer",
  "productTheme/LDF": "produkttemaer/bakte-gronnsaker",
  "productTheme/LEG": "produkttemaer/belgfrukter",
  "productTheme/LGO": "produkttemaer",
  "productTheme/LGR": "produkttemaer",
  "productTheme/LGS": "produkttemaer",
  "productTheme/MAI": "produkttemaer/mais",
  "productTheme/MUS": "produkttemaer/sjampinjonger",
  "productTheme/NEW": "produkttemaer/nyheter",
  "productTheme/PDH": "produkttemaer",
  "productTheme/PDL": "produkttemaer",
  "productTheme/PHR": "produkttemaer",
  "productTheme/PLP": "produkttemaer/hovedrett",
  "productTheme/RAL": "produkttemaer",
  "productTheme/RDM": "produkttemaer",
  "productTheme/SAL": "produkttemaer",
  "productTheme/SDB": "produkttemaer/salatboller",
  "productTheme/SNK": "produkttemaer",
  "productTheme/SUP": "produkttemaer/suppe",
  "productTheme/TEX": "produkttemaer/tex-mex",
  "productTheme/VGP": "produkttemaer",
  "recipeTheme": "oppskriftstema",
  "recipeTheme/01": "oppskriftstema/hoytider",
  "recipeTheme/02": "oppskriftstema",
  "recipeTheme/03": "oppskriftstema/salat-og-snacks",
  "recipeTheme/04": "oppskriftstema/supper",
  "recipeTheme/05": "oppskriftstema",
  "recipeTheme/06": "oppskriftstema",
  "recipeTheme/07": "oppskriftstema/desserter",
  "recipeTheme/08": "oppskriftstema/vegetarmat",
  "recipeTheme/09": "oppskriftstema/tilbehor",
  "recipeTheme/10": "oppskriftstema",
  "recipeTheme/11": "oppskriftstema",
  "recipeTheme/12": "oppskriftstema",
  "recipeTheme/13": "oppskriftstema/snacks-og-fingermat",
  "recipeTheme/14": "oppskriftstema/hovedretter",
  "recipeTheme/15": "oppskriftstema/desserter-og-bakverk",
  "recipeTheme/16": "oppskriftstema/forretter-og-supper",
  "recipeTheme/17": "oppskriftstema/salater",
  "recipeTheme/18": "oppskriftstema/bowls",
  "recipeTheme/19": "oppskriftstema/supper",
  "recipeTheme/20": "oppskriftstema",
  "recipeTheme/21": "oppskriftstema/sauser",
  "recipeTheme/22": "oppskriftstema",
  "recipeTheme/23": "oppskriftstema/andre-retter",
  "recipeTheme/24": "oppskriftstema/ovnsbakte-retter",
  "recipeTheme/25": "oppskriftstema",
  "recipeTheme/26": "oppskriftstema",
  "recipeTheme/27": "oppskriftstema",
  "recipeTheme/28": "oppskriftstema",
  "recipeTheme/33": "oppskriftstema",
  "recipeTheme/34": "oppskriftstema",
  "recipeTheme/35": "oppskriftstema",
  "recipeTheme/36": "oppskriftstema",
  "recipeTheme/37": "oppskriftstema",
  "recipeTheme/38": "oppskriftstema",
  "recipeTheme/39": "oppskriftstema",
  "recipeTheme/40": "oppskriftstema",
  "recipeTheme/41": "oppskriftstema",
  "recipeTheme/42": "oppskriftstema",
  "recipeTheme/43": "oppskriftstema",
  "recipeTheme/44": "oppskriftstema",
  "recipeTheme/45": "oppskriftstema",
  "recipeTheme/46": "oppskriftstema",
  "pred-particularite": "kategorier",
  "pred-particularite/Sans%20conservateur": "kategorier/uten-konserveringsmidler",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "kategorier",
  "pred-particularite/Sans%20colorant": "kategorier/uten-fargestoffer",
  "pred-particularite/Sans%20sucre%20ajout%E9": "kategorier/uten-tilsatt-sukker",
  "pred-particularite/Sans%20sel%20ajout%E9": "kategorier/uten-tilsatt-salt",
  "pred-particularite/Sans%20additif": "kategorier/uten-tilsetningsstoffer",
  "pred-particularite/": "kategorier/med-et-naturlig-innhold-av-salt",
  "pred-particularite/Sans%20lactose": "kategorier/laktosefri",
  "pred-particularite/Sans%20gluten": "kategorier/glutenfri",
  "pred-particularite/V%E9g%E9tarien": "kategorier/vegetarisk",
  "pred-particularite/V%E9g%E9talien": "kategorier/vegansk",
  "pred-particularite/Sans%20sulfite": "kategorier",
  "pred-particularite/A%20la%20vapeur": "kategorier",
  "pred-particularite/Sans%20condiment": "kategorier",
  "cultureType": "vis-kun",
  "cultureType/Bio": "vis-kun/okologisk",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "vis-kun/ingen-pesticidrester",
  "cultureType/Sans%20OGM": "vis-kun/uten-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "kategorier/vegansk",
  "pred-particularite/recipeVeggie": "kategorier/vegetarisk",
  "pred-particularite/recipeGlutenfree": "kategorier/glutenfri",
  "pred-particularite/recipeLactosefree": "kategorier/laktosefri"
};
